import React from 'react'
import { graphql } from 'gatsby'
import style from './share.mod.scss'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton
} from 'react-share'
import FacebookSvg from '@svgs/facebook.svg'
import TwitterSvg from '@svgs/twitter.svg'
import LinkedInSvg from '@svgs/linkedin.svg'

const Share = ({ title, url, facebook, linkedIn, twitter }) => {
  return (
    <div className={style.share}>
      <h4 className={style.share__heading}>{`Share Article:`}</h4>
      <div className={style.share__icons}>
        {facebook && (
          <FacebookShareButton url={url}>
            <FacebookSvg />
          </FacebookShareButton>
        )}

        {linkedIn && (
          <LinkedinShareButton url={url} title={title}>
            <LinkedInSvg />
          </LinkedinShareButton>
        )}

        {twitter && (
          <TwitterShareButton url={url} title={title}>
            <TwitterSvg />
          </TwitterShareButton>
        )}
      </div>
    </div>
  )
}

export default Share

export const query = graphql`
  fragment Share on DatoCmsSharePost {
    id
    background
    padding
    model {
      apiKey
    }
    twitter
    linkedIn
    facebook
  }
`
